import { Search } from "@outschool/business-rules";
import { dayjs } from "@outschool/time";
import lodashValues from "lodash/values";

const dayjsToday = () => dayjs().startOf("day");

export default function filterToDayjs(
  startAfter: string,
  startBefore: string | null
) {
  const startDayjs = !lodashValues(Search.RelativeDateFilter).some(
    val => val === startAfter
  )
    ? dayjs(startAfter)
    : startAfter === Search.RelativeDateFilter.NextWeek
    ? dayjsToday().add(1, "week").day("Monday")
    : startAfter === Search.RelativeDateFilter.NextMonth
    ? dayjsToday().add(1, "month").startOf("month")
    : startAfter === Search.RelativeDateFilter.Summer
    ? dayjs.max(dayjsToday().set("month", 5).set("date", 1), dayjsToday())
    : startAfter === Search.RelativeDateFilter.Fall
    ? dayjs.max(dayjsToday().set("month", 8).set("date", 1), dayjsToday())
    : startAfter === Search.RelativeDateFilter.January
    ? dayjs.max(
        dayjsToday().set("month", 0).add(1, "year").set("date", 1),
        dayjsToday()
      )
    : dayjsToday();
  const endDayjs =
    !lodashValues(Search.RelativeDateFilter).some(val => val === startBefore) &&
    startBefore
      ? dayjs(startBefore)
      : startAfter === Search.RelativeDateFilter.Today
      ? dayjsToday()
      : startAfter === Search.RelativeDateFilter.SevenDays
      ? dayjsToday().add(6, "days")
      : startAfter === Search.RelativeDateFilter.FourteenDays
      ? dayjsToday().add(13, "days")
      : startAfter === Search.RelativeDateFilter.Summer
      ? dayjsToday().set("month", 7).set("date", 31)
      : startAfter === Search.RelativeDateFilter.Fall
      ? dayjsToday().set("month", 10).set("date", 30)
      : startAfter === Search.RelativeDateFilter.January
      ? dayjsToday().set("month", 0).add(1, "year").set("date", 31)
      : undefined;
  return {
    startDayjs,
    endDayjs,
  };
}
